/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-pages';
const componentName = 'error-page';
const prefix = `${moduleName}.${componentName}`;

export const unauthorizedLabel = `${prefix}.unauthorizedLabel`;
export const cspLabel = `${prefix}.cspLabel`;
export const unAuthorizedAccessHeaderLabel = `${prefix}.unAuthorizedAccessHeaderLabel`;

export const ENGLISH = {
    [unauthorizedLabel]: 'User is not Authorized to access the controller. Retry Logging in to',
    [cspLabel]: 'CSP',
    [unAuthorizedAccessHeaderLabel]: 'Unauthorized Access',
};
